import { BaseService } from './base';

import { CustomerNote } from '../models/customerNote';

export class CustomerNoteService extends BaseService<CustomerNote> {
  override model = CustomerNote;
  override modelName = 'customerNote';
  override modelLabel = 'Customer Notes';
}
